import { ArrowRight } from 'lucide-react';
import { LogoMark } from '@/components/LogoMark';
import { SHOPIFY_PRODUCT_URL } from '@/shopify';
import { goToCheckout } from '@/lib/shopifyClient';
import { HOME } from '@/constants/testIds';
import { scrollToId } from '@/lib/scrollTo';

export const Navbar = () => (
    <header
        data-testid={HOME.nav}
        className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-xl"
    >
        <nav className="mx-auto flex h-14 max-w-6xl items-center justify-between px-6">
            <a
                href="#hero"
                data-testid={HOME.navHome}
                onClick={scrollToId('hero')}
                className="flex items-center gap-2.5"
                aria-label="ENGINE — back to top"
            >
                <LogoMark className="h-6 w-6" />
                <span className="text-[15px] font-semibold tracking-[0.18em] text-white">ENGINE</span>
            </a>

            <div className="hidden items-center gap-8 md:flex">
                <a
                    href="#features"
                    data-testid={HOME.navFeaturesLink}
                    onClick={scrollToId('features')}
                    className="text-sm text-zinc-400 transition-colors hover:text-white"
                >
                    Features
                </a>
                <a
                    href="#how-it-works"
                    data-testid={HOME.navHowLink}
                    onClick={scrollToId('how-it-works')}
                    className="text-sm text-zinc-400 transition-colors hover:text-white"
                >
                    How it works
                </a>
            </div>

            <a
                data-testid={HOME.navGetEngine}
                href={SHOPIFY_PRODUCT_URL}
                onClick={goToCheckout}
                className="group inline-flex h-9 items-center gap-1.5 rounded-full bg-aqua px-4 text-sm font-medium text-ink transition-all duration-300 hover:shadow-glow hover:brightness-110"
            >
                Get ENGINE
                <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5" />
            </a>
        </nav>
    </header>
);
